import {OidcSecurityService} from 'angular-auth-oidc-client';

import {environment} from '../../../environments/environment';

export const logoutLandingUrl = () => window.location.origin + '/ui/logout';

/** Complete OIDC logout, including expired sessions that do not redirect. */
export function logoutWithFallback(
  oidcSecurityService: Pick<OidcSecurityService, 'logoff' | 'logoffLocalMultiple'>,
  redirectTo: (url: string) => void,
): void {
  let redirectStarted = false;
  let fallbackApplied = false;

  const applyFallback = (): void => {
    if (redirectStarted || fallbackApplied) {
      return;
    }
    fallbackApplied = true;
    oidcSecurityService.logoffLocalMultiple();
    redirectTo(logoutLandingUrl());
  };

  // The library builds the end-session URL with the ID token and configured
  // post-logout redirect. Expired sessions can complete without opening it.
  oidcSecurityService.logoff(undefined, {
    customParams: {client_id: environment.clientId},
    urlHandler: url => {
      redirectStarted = true;
      redirectTo(url);
    },
  }).subscribe({
    next: applyFallback,
    error: applyFallback,
    complete: applyFallback,
  });
}
